import shouldTrackEventDefault from './shouldTrackEvent';
import withAdContextData from './withAdContextData';
import { log, logEvent } from '../utils/loggingUtil';
export function track(withEventData, adSpot) {
  var shouldTrackEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : shouldTrackEventDefault;

  try {
    var eventData = withEventData(adSpot);

    if (!eventData) {
      return;
    }

    var context = withAdContextData(adSpot);
    logEvent(eventData, context);
    var tracking = adSpot.tracking;

    if (shouldTrackEvent(tracking)) {
      tracking.trackEvent(eventData, context);
      log('Event tracked');
    }
  } catch (error) {
    console.error(error);
  }
}
//# sourceMappingURL=index.js.map